import { useMemo } from 'react'
import * as THREE from 'three'
import type { VehicleSceneTheme } from './VehicleSceneTheme'

const M = (mm: number) => mm / 1000
const toScene = (x: number, y: number, z: number): [number, number, number] => [M(x), M(z), M(y)]

function arm(start: THREE.Vector3, end: THREE.Vector3) {
  const direction = end.clone().sub(start)
  return {
    midpoint: start.clone().add(direction.clone().multiplyScalar(0.5)),
    length: direction.length(),
    quaternion: new THREE.Quaternion().setFromUnitVectors(
      new THREE.Vector3(0, 1, 0),
      direction.normalize(),
    ),
  }
}

/** Timon en V pour une remorque routière, hors conteneur et semi-remorque. */
export function VehicleTowbar({ width, theme }: { width: number; theme: VehicleSceneTheme }) {
  const hitchX = -1300
  const hitchY = width / 2
  const arms = useMemo(() => [
    arm(
      new THREE.Vector3(...toScene(hitchX, hitchY, 120)),
      new THREE.Vector3(...toScene(0, width * 0.15, 220)),
    ),
    arm(
      new THREE.Vector3(...toScene(hitchX, hitchY, 120)),
      new THREE.Vector3(...toScene(0, width * 0.85, 220)),
    ),
  ], [width, hitchY])

  return (
    <group>
      {arms.map((part, index) => (
        <mesh key={index} position={part.midpoint} quaternion={part.quaternion} castShadow>
          <cylinderGeometry args={[M(45), M(45), part.length, 10]} />
          <meshStandardMaterial color={theme.chassis} metalness={0.7} roughness={0.4} />
        </mesh>
      ))}
      <mesh position={toScene(hitchX, hitchY, 120)}>
        <sphereGeometry args={[M(90), 16, 16]} />
        <meshStandardMaterial color="#f59e0b" metalness={0.6} roughness={0.3} />
      </mesh>
    </group>
  )
}
